/* ck-ui.js — Grok 50 Greenfield
 * DOM only: vehicle bar, header vehicle reminder, <ck-configurator>, PDP gallery.
 * Depends on ck-core.js (window.CK).
 */
(function () {
  'use strict';
  if (!window.CK) {
    try { console.error('[ck-ui] CK core missing — load ck-core.js first'); } catch (e) {}
    return;
  }
  var CK = window.CK;

  function h(tag, attrs, html) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') el.className = attrs[k];
      else if (k.slice(0, 2) === 'on' && typeof attrs[k] === 'function') el.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
      else if (attrs[k] != null && attrs[k] !== false) el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    if (html != null) el.innerHTML = html;
    return el;
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function safeImgUrl(v) {
    if (!v) return '';
    try { var u = new URL(String(v), location.origin); return (u.protocol === 'http:' || u.protocol === 'https:') ? String(v) : ''; }
    catch (e) { return ''; }
  }
  var _diagBox;
  function openDiagram(url, cap) {
    url = safeImgUrl(url); if (!url) return;
    if (!_diagBox) {
      _diagBox = h('div', { class: 'ck-cfg__lightbox', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Fit diagram', hidden: '' });
      _diagBox.innerHTML = '<div class="ck-cfg__lightbox-inner"><button type="button" class="ck-cfg__lightbox-close" aria-label="Close">&times;</button><img class="ck-cfg__lightbox-img" alt=""><div class="ck-cfg__lightbox-cap"></div></div>';
      var close = function () { _diagBox.hidden = true; };
      _diagBox.querySelector('.ck-cfg__lightbox-close').onclick = close;
      _diagBox.onclick = function (e) { if (e.target === _diagBox) close(); };
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !_diagBox.hidden) close(); });
      document.body.appendChild(_diagBox);
    }
    _diagBox.querySelector('.ck-cfg__lightbox-img').src = url;
    _diagBox.querySelector('.ck-cfg__lightbox-cap').textContent = cap || '';
    _diagBox.hidden = false;
  }

  
  
  // The year, make and model selects, each filling the next from the store. Every change takes a
  // ticket, and an answer is used only while its ticket is still the latest, so a slow reply to an
  // earlier choice never fills the lists, or sets the base vehicle, of the current one. Returns
  // `claim`, a ticket for a caller filling the selects itself: true until the customer chooses.
  function wireCascade(els, cb) {
    var status = cb.status || function () {};
    var onBase = cb.onBase || function () {};
    var onChange = cb.onChange || function () {};
    var ticket = 0;
    function ask(request, ok, fail) {
      var mine = ticket;
      request.then(function (r) { if (mine === ticket) ok(r); })
        .catch(function () { if (mine === ticket) fail(); });
    }
    els.year.addEventListener('change', function () {
      ticket++;
      onBase('');
      cb.reset(els.make, 'Make'); cb.reset(els.model, 'Model'); cb.reset(els.sub, 'Submodel');
      onChange();
      if (!els.year.value) return;
      ask(CK.getMakes(els.year.value), function (makes) { status(''); cb.fill(els.make, makes, 'Make'); },
        function () { status('Could not load makes', true); });
    });
    els.make.addEventListener('change', function () {
      ticket++;
      onBase('');
      cb.reset(els.model, 'Model'); cb.reset(els.sub, 'Submodel');
      onChange();
      if (!els.make.value) return;
      ask(CK.getModels(els.year.value, els.make.value), function (models) { status(''); cb.fill(els.model, models, 'Model'); },
        function () { status('Could not load models', true); });
    });
    els.model.addEventListener('change', function () {
      ticket++;
      onBase('');
      cb.reset(els.sub, 'Submodel');
      onChange();
      if (!els.model.value) return;
      ask(CK.getSubmodels(els.year.value, els.make.value, els.model.value), function (sm) {
        status('');
        onBase((sm && sm.baseVehicle) || '');
        cb.fill(els.sub, (sm && sm.subModels) || [], 'Submodel');
        onChange();
      }, function () { status('Could not load submodels', true); });
    });
    els.sub.addEventListener('change', onChange);
    return { claim: function () { var mine = ++ticket; return function () { return mine === ticket; }; } };
  }

  function bootVbar(root) {
    if (!root || root.hasAttribute('data-ck-init')) return;
    root.setAttribute('data-ck-init', '');
    var elYear = root.querySelector('[data-ck-vbar-year]');
    var elMake = root.querySelector('[data-ck-vbar-make]');
    var elModel = root.querySelector('[data-ck-vbar-model]');
    var elSub = root.querySelector('[data-ck-vbar-submodel]');
    var elCat = root.querySelector('[data-ck-vbar-category]');
    var elStatus = root.querySelector('[data-ck-vbar-status]');
    var elFallback = root.querySelector('[data-ck-vbar-fallback]');
    var baseVehicle = '';

    function fill(sel, items, placeholder) {
      sel.innerHTML = '';
      sel.appendChild(h('option', { value: '' }, placeholder));
      (items || []).forEach(function (it) {
        var v = typeof it === 'string' ? it : String(it);
        sel.appendChild(h('option', { value: v }, esc(v)));
      });
      sel.disabled = !(items && items.length);
    }
    function reset(sel, ph) { fill(sel, [], ph); sel.disabled = true; }
    function status(msg, isErr) {
      if (!elStatus) return;
      if (!msg) { elStatus.hidden = true; elStatus.textContent = ''; return; }
      elStatus.hidden = false; elStatus.textContent = msg;
      elStatus.classList.toggle('is-error', !!isErr);
    }
    function vehicleReady() {
      return !!(elYear.value && elMake.value && elModel.value && elSub.value);
    }
    function persist() {
      CK.setVehicle({
        year: elYear.value, make: elMake.value, model: elModel.value,
        submodel: elSub.value, baseVehicle: baseVehicle
      });
    }
    function unlockCat() {
      if (!elCat) return;
      elCat.disabled = !vehicleReady();
    }
    function goCategory() {
      if (!elCat || !elCat.value || !vehicleReady()) return;
      persist();
      window.location.href = elCat.value;
    }

    var cascade = wireCascade(
      { year: elYear, make: elMake, model: elModel, sub: elSub },
      {
        fill: fill, reset: reset, status: status,
        onBase: function (b) { baseVehicle = b; },
        onChange: function () {
          unlockCat();
          if (vehicleReady()) persist();
        }
      });

    // The saved vehicle is restored step by step; a choice the customer makes meanwhile ends the restore.
    var preset = CK.getVehicle();
    var mine = cascade.claim();
    CK.getYears().then(function (years) {
      status('');
      if (elFallback) elFallback.hidden = true;
      fill(elYear, years, 'Year');
      if (preset && preset.year) {
        elYear.value = preset.year;
        return CK.getMakes(preset.year).then(function (makes) {
          if (!mine()) return;
          fill(elMake, makes, 'Make');
          elMake.value = preset.make || '';
          if (!preset.make) return;
          return CK.getModels(preset.year, preset.make).then(function (models) {
            if (!mine()) return;
            fill(elModel, models, 'Model');
            elModel.value = preset.model || '';
            if (!preset.model) return;
            return CK.getSubmodels(preset.year, preset.make, preset.model).then(function (sm) {
              if (!mine()) return;
              baseVehicle = (sm && sm.baseVehicle) || preset.baseVehicle || '';
              fill(elSub, (sm && sm.subModels) || [], 'Submodel');
              if (preset.submodel) elSub.value = preset.submodel;
              unlockCat();
            });
          });
        });
      }
    }).catch(function () {
      if (!mine()) return; // a restore the customer has taken over has nothing left to report
      if (elFallback) elFallback.hidden = false;
      status('Could not load vehicles', true);
    });
    if (elCat) {
      elCat.addEventListener('change', function () {
        if (elCat.disabled) return;
        if (elCat.value) goCategory();
      });
    }
  }

  
  function paintHeaderFit() {
    var el = document.querySelector('[data-header-fit]');
    if (!el) return;
    var v = CK.getVehicle();
    var show = !!(v && v.year && v.model) && !document.querySelector('[data-ck-vbar]');
    el.hidden = !show;
    if (show) {
      var label = el.querySelector('.header-fit__label');
      if (label) label.textContent = "'" + String(v.year).slice(-2) + ' ' + v.model;
    }
  }
  var headerFitBound = false;
  function bootHeaderFit() {
    if (!headerFitBound) {
      headerFitBound = true;
      document.addEventListener('ck:vehicle-changed', paintHeaderFit);
    }
    paintHeaderFit();
  }

  
  /* Sole swatch is an implicit selection — no click/state required. */
  function soleName(colors) {
    return colors && colors.length === 1 ? colors[0].name : '';
  }

  if (!customElements.get('ck-configurator')) {
  customElements.define('ck-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      if (window.__ckV2Configurator === false || this.hasAttribute('data-ck-disable')) {
        this.setAttribute('data-ck-state', 'disabled');
        return;
      }
      this.family = this.getAttribute('data-family') || '';
      this.handle = this.getAttribute('data-material-handle') || this.getAttribute('data-handle') || '';
      this.proid = this.getAttribute('data-proid') || '';
      this.mcat = this.getAttribute('data-mcat') || '';
      this.onlymat = this.getAttribute('data-onlymat') || '';
      this.nomat = this.getAttribute('data-nomat') || '';
      this.profile = CK.profile(this.family);
      this.state = {
        status: 'boot', vehicle: null, resolved: null, error: null,
        positions: {}, configByPosition: {}, colorByPosition: {},
        primaryColor: '', configRecid: null, msg: '', waitlist: ''
      };
      this._abort = null;
      this._seq = 0;
      this._hidden = [];
      this._onVehicle = this._onVehicle.bind(this);
      this._onAddonsChanged = this._onAddonsChanged.bind(this);
      document.addEventListener('ck:vehicle-changed', this._onVehicle);
      document.addEventListener('ck:addons-changed', this._onAddonsChanged);
      this._mount();
      if (!this.profile) {
        this.setAttribute('data-ck-state', 'no-profile');
        return;
      }
      this._hideNative();
      this._boot();
    }
    disconnectedCallback() {
      document.removeEventListener('ck:vehicle-changed', this._onVehicle);
      document.removeEventListener('ck:addons-changed', this._onAddonsChanged);
      if (this._abort) try { this._abort.abort(); } catch (e) {}
    }
    _mount() {
      if (this._root) return;
      this._root = h('div', { class: 'ck-cfg', 'data-ck-cfg-root': '' });
      // Add to cart renders after the form, so the form's add-ons sit between the options and
      // the button. insertBefore with a null reference appends.
      this._actions = h('div', { class: 'ck-cfg__actions' });
      var form = this.querySelector('form');
      this.insertBefore(this._root, form);
      this.insertBefore(this._actions, form ? form.nextSibling : null);
    }
    _nativeForm() {
      return this.querySelector('form[action*="/cart/add"]') ||
        (this.closest('section') && this.closest('section').querySelector('form[action*="/cart/add"]'));
    }
    _hideNative() {
      var self = this;
      function hide(el) {
        if (!el || el.closest('[data-ck-cfg-root]')) return;
        if (el.style) el.style.display = 'none';
        if (el.matches && el.matches('[data-atc-button], button[name="add"], button[type="submit"]')) {
          el.disabled = true;
          el.setAttribute('data-ck-disabled', '');
        }
        self._hidden.push(el);
      }
      var form = this._nativeForm();
      if (form) {
        
        if (!form._ckLocked) {
          form._ckLocked = true;
          form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); });
          form.submit = function () {};
        }
        form.querySelectorAll(
          'select[name^="options"], select[data-variant-select], .pdp__options, .pdp__buy, .product-form__input, [data-atc-button]'
        ).forEach(hide);
      }
      var scope = this.closest('.pdp__info') || this.closest('section') || document;
      scope.querySelectorAll('.pdp__fitbar, .pdp__price, .pdp__made, .pdp__price-gate').forEach(function (el) {
        if (el.closest('[data-ck-cfg-root]')) return;
        hide(el);
      });
    }
    _onVehicle() {
      this.state.vehicle = CK.getVehicle();
      this._resetSel();
      if (this.state.vehicle) this._resolve();
      else { this.state.status = 'needs-vehicle'; this.render(); }
    }
    _boot() {
      this.state.vehicle = CK.getVehicle();
      if (!this.state.vehicle) { this.state.status = 'needs-vehicle'; this.render(); return; }
      this._resolve();
    }
    _resetSel() {
      this.state.positions = {};
      this.state.configByPosition = {};
      this.state.colorByPosition = {};
      this.state.primaryColor = '';
      this.state.configRecid = null;
      this.state.resolved = null;
      this.state.error = null;
      this.state.msg = '';
      this.state.waitlist = '';
    }
    _resolve() {
      if (this._abort) try { this._abort.abort(); } catch (e) {}
      this._abort = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var seq = ++this._seq;
      var self = this;
      this.state.status = 'loading';
      this.render();
      CK.resolve(this.state.vehicle, this.handle, this.family, {
        signal: this._abort && this._abort.signal,
        onlymat: this.onlymat, nomat: this.nomat,
        productId: this.proid, mcat: this.mcat
      }).then(function (res) {
        if (seq !== self._seq) return;
        self.state.resolved = res;
        if (res.error && res.error.code === 'OPTIONS_EMPTY') {
          self.state.status = 'empty'; self.state.error = res.error;
        } else if (!res.skuIndex.length) {
          self.state.status = 'empty';
        } else {
          self.state.status = 'ready';
          self._autoselect(res);
        }
        self.render();
      }).catch(function (err) {
        if (seq !== self._seq) return;
        if (err && err.name === 'AbortError') return;
        self.state.status = 'error';
        self.state.error = err;
        self.render();
      });
    }
    _autoselect(res) {
      if (this.profile.selectionMode !== 'single-line') return;
      var cfgs = res.configsFor('Default');
      if (cfgs.length === 1) this.state.configRecid = cfgs[0].recid;
    }
    _selectedSkus() {
      var res = this.state.resolved; if (!res) return [];
      var p = this.profile, st = this.state, self = this;
      if (p.selectionMode === 'multi-line') {
        var out = [];
        // In the fitment's order, so the first line is the front row whatever was ticked first.
        res.positions.forEach(function (entry) {
          var pos = entry.position;
          if (!st.positions[pos]) return;
          var sel = { position: pos };
          if (st.configByPosition[pos] != null) sel.recid = st.configByPosition[pos];
          var m = res.select(sel);
          if (m[0]) {
            out.push(CK.applyColorPrice(m[0], st.colorByPosition[pos] || soleName(res.colors)));
          }
        });
        return out;
      }
      var filt = {};
      if (st.configRecid != null) filt.recid = st.configRecid;
      var sel = res.select(filt);
      return sel[0] ? [CK.applyColorPrice(sel[0], st.primaryColor || soleName(res.colors))] : [];
    }
    _colorMeta(name, sku) {
      var list = (sku && sku.colors) || (this.state.resolved && this.state.resolved.colors) || [];
      for (var i = 0; i < list.length; i++) if (list[i].name === name) return list[i];
      return null;
    }
    _validate() {
      var errs = [], p = this.profile, st = this.state, skus = this._selectedSkus();
      if (!st.vehicle) errs.push('Select your vehicle');
      if (!st.resolved) errs.push('Select a material');
      if (p.selectionMode === 'multi-line') {
        if (!Object.keys(st.positions).length) errs.push('Select at least one position');
        Object.keys(st.positions).forEach(function (pos) {
          var cfgs = st.resolved ? st.resolved.configsFor(pos) : [];
          if (cfgs.length > 1 && st.configByPosition[pos] == null) errs.push('Select a configuration for ' + pos);
          if (p.color.required && !(st.colorByPosition[pos] || soleName(st.resolved.colors))) errs.push('Select a color for ' + pos);
        });
      } else {
        var c = st.resolved ? st.resolved.configsFor('Default') : [];
        if (c.length > 1 && st.configRecid == null) errs.push('Select a fitment option');
        if (p.color.required && !(st.primaryColor || soleName(st.resolved && st.resolved.colors))) errs.push('Select a color');
      }
      if (!skus.length || skus.some(function (s) { return !s || !s.variantId || s.axisUnresolved; })) {
        if (!errs.length) errs.push('This option isn’t available for your vehicle');
      }
      if (skus.some(function (s) { return s && s.available === false && !s.axisUnresolved; })) {
        errs.push('This selection is currently sold out');
      }
      return errs;
    }
    _propsForSkus(skus) {
      var self = this, p = this.profile, st = this.state;
      return skus.map(function (sku) {
        var colorName = (p.selectionMode === 'multi-line' ? st.colorByPosition[sku.position] : st.primaryColor)
          || soleName(st.resolved && st.resolved.colors);
        var meta = self._colorMeta(colorName, sku);
        return CK.cartProperties(self.family, {
          vehicle: st.vehicle, sku: sku,
          primaryColor: colorName, color: colorName,
          colorMaterialId: meta && meta.materialId,
          colorMaterialName: meta && meta.name
        });
      });
    }
    // The add-ons snippet registers CK.addons.selection on pages that have add-ons.
    _addonSelection() {
      var fn = CK.addons && CK.addons.selection;
      return fn ? fn() : { lines: [], parentProperties: {}, totalCents: 0 };
    }
    // An add-on changes the total and nothing else: only the Add to cart is redrawn.
    _onAddonsChanged() {
      if (this.state.status === 'ready') this._renderActions();
    }
    _renderActions() {
      this._actions.replaceChildren(this._renderATC());
    }
    _addToCart() {
      var errs = this._validate();
      if (errs.length) { this.state.msg = errs[0]; this.render(); return; }
      var skus = this._selectedSkus();
      var props = this._propsForSkus(skus);
      var addons = this._addonSelection();
      Object.assign(props[0], addons.parentProperties);
      var self = this;
      this.state.status = 'adding'; this.state.msg = ''; this.render();
      CK.addToCart(skus, props, null, addons.lines).then(function () {
        self.state.status = 'ready';
        self.state.msg = 'Added to cart';
        self.render();
        try {
          if (typeof window.__ckAfterAddToCart === 'function') window.__ckAfterAddToCart();
        } catch (e) {}
      }).catch(function (err) {
        self.state.status = 'ready';
        self.state.msg = (err && err.message) || 'Could not add to cart';
        self.render();
      });
    }
    _requestVehicleChange() {
      if (this._abort) try { this._abort.abort(); } catch (e) {}
      this._seq++;
      CK.clearVehicle();
      this.state.vehicle = null;
      this._resetSel();
      this.state.status = 'needs-vehicle';
      this.render();
    }
    render() {
      var st = this.state, p = this.profile, root = this._root;
      if (!root) return;
      this.setAttribute('data-ck-state', st.status);
      root.innerHTML = '';
      this._actions.innerHTML = '';
      try {
        document.dispatchEvent(new CustomEvent('ck:fitment-readiness', { detail: { state: st.status } }));
      } catch (e) {}

      if (st.status === 'needs-vehicle') {
        root.appendChild(this._renderVehiclePicker());
        this._syncFitSubtitle();
        return;
      }
      if (st.status === 'loading' || st.status === 'boot' || st.status === 'adding') {
        root.appendChild(h('div', { class: 'ck-cfg__notice', role: 'status' },
          st.status === 'adding' ? 'Adding to cart…' : 'Checking fit for your vehicle…'));
        this._syncFitSubtitle();
        return;
      }
      if (st.status === 'empty') {
        var emptyMsg = 'This product isn’t available for a ' + esc(st.vehicle && st.vehicle.display) + '.';
        if (st.error && st.error.code === 'OPTIONS_EMPTY') {
          emptyMsg += '<br>To help us match or create the right part, please add any extra details about your request. Do you have a vehicle we can measure? If you’re able to assist with measurements, we’d welcome your help getting the pattern. Leave your email and we’ll contact you if and when a pattern becomes available.';
        }
        root.appendChild(h('div', { class: 'ck-cfg__notice ck-cfg__notice--warn', role: 'alert' }, emptyMsg));
        if (st.error && st.error.code === 'OPTIONS_EMPTY') root.appendChild(this._renderWaitlist());
        root.appendChild(this._changeLink());
        this._syncFitSubtitle();
        return;
      }
      if (st.status === 'error') {
        var code = st.error && st.error.code;
        var msg = code === 'NO_BASE_VEHICLE'
          ? 'We couldn’t confirm this vehicle. Please re-select it or contact support.'
          : ((st.error && st.error.message) || 'Something went wrong loading fitment.');
        var box = h('div', { class: 'ck-cfg__notice ck-cfg__notice--warn', role: 'alert' }, esc(msg) + ' ');
        var retry = h('button', { type: 'button', class: 'ck-cfg__link' }, 'Try again');
        var self = this;
        retry.addEventListener('click', function () { self._resolve(); });
        box.appendChild(retry);
        root.appendChild(box);
        root.appendChild(this._changeLink());
        this._syncFitSubtitle();
        return;
      }

      
      if (!this._fitTarget()) root.appendChild(this._fitHeader());
      if (p.selectionMode === 'multi-line') root.appendChild(this._renderPositions());
      else root.appendChild(this._renderSingle());
      if (st.msg) root.appendChild(h('p', { class: 'ck-cfg__msg', role: 'status' }, esc(st.msg)));
      this._renderActions();
      this._syncFitSubtitle();
    }
    _fitTarget() {
      var info = this.closest('.pdp__info');
      return info && info.querySelector('[data-ck-fit-target]');
    }
    _renderWaitlist() {
      var st = this.state, self = this;
      if (st.waitlist) {
        return h('p', { class: 'ck-cfg__notice', role: 'status' }, esc(st.waitlist));
      }
      var form = h('form', { class: 'ck-cfg__wait' });
      var row = h('div', { class: 'ck-cfg__wait-row' });
      var input = h('input', {
        type: 'email', name: 'email', required: true, autocomplete: 'email',
        class: 'ck-cfg__wait-input', placeholder: 'Email address', 'aria-label': 'Email address'
      });
      var extra = h('textarea', {
        name: 'comment', rows: '3', class: 'ck-cfg__wait-input ck-cfg__wait-note',
        placeholder: 'Optional details', 'aria-label': 'Optional details'
      });
      var btn = h('button', { type: 'submit', class: 'ck-cfg__wait-go' }, 'Notify me');
      var note = h('p', { class: 'ck-cfg__wait-msg', role: 'alert' });
      row.appendChild(input); row.appendChild(btn);
      form.appendChild(row); form.appendChild(extra); form.appendChild(note);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var v = CK.getVehicle() || st.vehicle || {};
        var seq = self._seq;
        btn.disabled = true; input.readOnly = true; extra.readOnly = true; note.textContent = '';
        CK.reportMissingPattern({
          email: input.value, productId: self.proid, comment: extra.value,
          baseVehicle: v.baseVehicle, submodel: v.submodel,
          url: location.href, mcat: self.mcat
        }).then(function (d) {
          if (seq !== self._seq) return;
          self.state.waitlist = (d && d.messages) || 'We’ll email you when this pattern is available.';
          self.render();
        }).catch(function () {
          if (seq !== self._seq) return;
          btn.disabled = false; input.readOnly = false; extra.readOnly = false;
          note.textContent = 'Couldn’t send that. Try again.';
        });
      });
      return form;
    }
    _changeLink() {
      var a = h('button', { type: 'button', class: 'ck-cfg__link', 'data-ck-change': '' }, 'Change vehicle');
      var self = this;
      a.addEventListener('click', function () { self._requestVehicleChange(); });
      return a;
    }
    _fitHeader() {
      var wrap = h('div', { class: 'ck-cfg__veh' });
      var v = this.state.vehicle;
      wrap.appendChild(h('span', { class: 'ck-cfg__veh-check', 'aria-hidden': 'true' }, '✓'));
      wrap.appendChild(h('span', { class: 'ck-cfg__veh-label' }, 'Fits'));
      wrap.appendChild(h('span', { class: 'ck-cfg__veh-value' },
        '<strong>' + esc(v && (v.display || v.details)) + '</strong>'));
      wrap.appendChild(this._changeLink());
      return wrap;
    }
    _syncFitSubtitle() {
      var t = this._fitTarget(); if (!t) return;
      var st = this.state, v = st.vehicle, self = this;
      var show = !!(v && (st.status === 'ready' || st.status === 'resolving' || st.status === 'loading'));
      if (!show) { t.hidden = true; t.innerHTML = ''; return; }
      t.innerHTML =
        '<span class="pdp__fit-sub-check" aria-hidden="true"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M20 6 9 17l-5-5"/></svg></span>' +
        '<span class="pdp__fit-sub-text">Designed specifically for a <strong>' + esc(v.display || v.details) + '</strong></span>' +
        '<button type="button" class="pdp__fit-sub-change" data-ck-change>Change</button>';
      t.querySelector('[data-ck-change]').onclick = function () { self._requestVehicleChange(); };
      t.hidden = false;
    }
    _renderATC() {
      var self = this;
      var errs = this._validate();
      var skus = this._selectedSkus();
      var total = 0;
      skus.forEach(function (s) { if (s && s.price != null) total += s.price; });
      total += this._addonSelection().totalCents;
      var label = errs.length
        ? (errs[0])
        : ('Add to cart' + (total ? ' · ' + CK.money(total) : ''));
      var btn = h('button', {
        type: 'button',
        class: 'btn btn--lg btn--gold pdp-atc-btn ck-cfg__atc',
        disabled: !!errs.length
      }, esc(label));
      btn.addEventListener('click', function () { self._addToCart(); });
      var wrap = h('div', { class: 'ck-cfg__atc-wrap pdp__buy' });
      wrap.appendChild(btn);
      return wrap;
    }
    _renderVehiclePicker() {
      var self = this, wrap = h('div', { class: 'ck-cfg__vsel' });
      wrap.appendChild(h('div', { class: 'ck-cfg__vsel-title' }, 'Select your vehicle to see fitment options'));
      wrap.appendChild(h('p', { class: 'ck-cfg__vsel-hint' }, 'Year, make, model, then submodel.'));
      var grid = h('div', { class: 'ck-cfg__vsel-grid' });
      var elY = h('select', { class: 'ck-cfg__vsel-select' }); elY.appendChild(h('option', { value: '' }, 'Year'));
      var elM = h('select', { class: 'ck-cfg__vsel-select', disabled: true }); elM.appendChild(h('option', { value: '' }, 'Make'));
      var elD = h('select', { class: 'ck-cfg__vsel-select', disabled: true }); elD.appendChild(h('option', { value: '' }, 'Model'));
      var elS = h('select', { class: 'ck-cfg__vsel-select', disabled: true }); elS.appendChild(h('option', { value: '' }, 'Submodel'));
      grid.appendChild(elY); grid.appendChild(elM); grid.appendChild(elD); grid.appendChild(elS);
      wrap.appendChild(grid);
      var go = h('button', { type: 'button', class: 'ck-cfg__vsel-go', disabled: true }, 'Confirm vehicle');
      var msg = h('p', { class: 'ck-cfg__vsel-msg' });
      wrap.appendChild(go); wrap.appendChild(msg);

      function fill(sel, items, ph) {
        sel.innerHTML = ''; sel.appendChild(h('option', { value: '' }, ph));
        (items || []).forEach(function (it) {
          var v = (it && (it.value != null ? it.value : it)) || '';
          var lab = (it && (it.label != null ? it.label : it)) || v;
          sel.appendChild(h('option', { value: String(v) }, String(lab)));
        });
        sel.disabled = !(items && items.length);
      }
      var baseVehicle = '';
      wireCascade(
        { year: elY, make: elM, model: elD, sub: elS },
        {
          fill: fill,
          reset: function (sel, ph) { fill(sel, [], ph); },
          status: function (m) { msg.textContent = m || ''; },
          onBase: function (b) { baseVehicle = b; },
          onChange: function () {
            go.disabled = !(elY.value && elM.value && elD.value && elS.value && baseVehicle);
          }
        });
      go.addEventListener('click', function () {
        if (go.disabled) return;
        CK.setVehicle({
          year: elY.value, make: elM.value, model: elD.value,
          submodel: elS.value, baseVehicle: baseVehicle
        });
      });
      CK.getYears().then(function (years) { fill(elY, years, 'Year'); })
        .catch(function () { msg.textContent = 'Could not load years'; });
      return wrap;
    }
    
    _configGrid(cfgs, selectedRecid, onPick) {
      var grp = h('div', { class: 'ck-cfg__configs' });
      grp.appendChild(h('div', { class: 'ck-cfg__config-label' }, 'Select a fitment option'));
      var grid = h('div', { class: 'ck-cfg__config-grid' });
      cfgs.forEach(function (c) {
        var on = String(selectedRecid) === String(c.recid);
        var cell = h('div', { class: 'ck-cfg__config-cell' });
        var art = safeImgUrl(c.lineArt);
        if (art) {
          var dbtn = h('button', { type: 'button', class: 'ck-cfg__diagram',
            'aria-label': 'View fit diagram for ' + (c.optionsDescr || '') });
          dbtn.innerHTML = '<img class="ck-cfg__diagram-img" alt="" loading="lazy" src="' + esc(art) + '">';
          dbtn.onclick = function (e) { e.preventDefault(); openDiagram(art, c.optionsDescr); };
          cell.appendChild(dbtn);
        }
        var b = h('button', {
          type: 'button', class: 'ck-cfg__config' + (on ? ' is-selected' : ''),
          'aria-pressed': on ? 'true' : 'false'
        }, '<span class="ck-cfg__config-text">' + esc(c.optionsDescr) + '</span>');
        b.onclick = function () { onPick(c.recid); };
        cell.appendChild(b);
        grid.appendChild(cell);
      });
      grp.appendChild(grid);
      return grp;
    }
    _renderSingle() {
      var self = this, res = this.state.resolved, st = this.state, p = this.profile;
      var wrap = h('div', { class: 'ck-cfg__single' });
      var cfgs = res.configsFor('Default');
      if (cfgs.length > 1) {
        var grp = this._configGrid(cfgs, st.configRecid, function (recid) {
          st.configRecid = recid; self.render();
        });
        grp.classList.add('ck-cfg__configs--single');
        wrap.appendChild(grp);
      }
      if (res.colors && res.colors.length) {
        wrap.appendChild(h('div', { class: 'ck-cfg__color-label' }, 'Select a color'));
        wrap.appendChild(this._swatches(res.colors, st.primaryColor, function (name) {
          st.primaryColor = name; self.render();
        }));
      }
      var skus = this._selectedSkus();
      if (skus[0] && skus[0].priceText) {
        wrap.appendChild(h('p', { class: 'ck-cfg__price' },
          '<span class="ck-cfg__price-label">Price </span>' +
          '<span class="ck-cfg__price-value">' + esc(skus[0].priceText) + '</span>'));
      }
      return wrap;
    }
    _renderPositions() {
      var self = this, res = this.state.resolved, st = this.state, p = this.profile;
      var wrap = h('fieldset', { class: 'ck-cfg__positions' });
      wrap.appendChild(h('legend', { class: 'ck-cfg__legend' }, 'Select the row(s) to purchase'));
      res.positions.forEach(function (pos) {
        var skus = res.select({ position: pos.position });
        var checked = !!st.positions[pos.position];
        var sku = skus[0]
          ? CK.applyColorPrice(skus[0], st.colorByPosition[pos.position] || soleName(res.colors))
          : null;
        var priced = !!sku && sku.variantId != null && sku.available !== false && !sku.axisUnresolved;
        var rowEl = h('div', { class: 'ck-cfg__position' + (checked ? ' is-on' : '') });
        var id = 'ckpos-' + pos.position.replace(/\W+/g, '-');
        var cb = h('input', { type: 'checkbox', id: id });
        cb.checked = checked;
        cb.disabled = !priced;
        cb.addEventListener('change', function (e) {
          if (e.target.checked) st.positions[pos.position] = true;
          else {
            delete st.positions[pos.position];
            delete st.configByPosition[pos.position];
            delete st.colorByPosition[pos.position];
          }
          self.render();
        });
        var lab = h('label', { 'for': id, class: 'ck-cfg__position-label' },
          esc(pos.position) + (priced
            ? ' <span class="ck-cfg__position-price">' + esc(sku.priceText) + '</span>'
            : ' <span class="ck-cfg__position-na">unavailable</span>'));
        rowEl.appendChild(cb);
        rowEl.appendChild(lab);
        if (checked) {
          var cfgs = res.configsFor(pos.position);
          if (cfgs.length > 1) {
            rowEl.appendChild(self._configGrid(cfgs, st.configByPosition[pos.position], function (recid) {
              st.configByPosition[pos.position] = recid; self.render();
            }));
          } else if (cfgs.length === 1) st.configByPosition[pos.position] = cfgs[0].recid;
          if (p.color.scope === 'per-position') {
            rowEl.appendChild(h('div', { class: 'ck-cfg__color-label' }, 'Select a color'));
            rowEl.appendChild(self._swatches(res.colors, st.colorByPosition[pos.position], function (name) {
              st.colorByPosition[pos.position] = name; self.render();
            }));
          }
        }
        wrap.appendChild(rowEl);
      });
      return wrap;
    }
    _swatches(colors, selected, onPick) {
      selected = selected || soleName(colors);
      var box = h('div', { class: 'ck-cfg__swatches' });
      (colors || []).forEach(function (c) {
        var on = selected === c.name;
        var b = h('button', {
          type: 'button',
          class: 'ck-cfg__swatch' + (on ? ' is-selected' : ''),
          title: c.name,
          'aria-label': c.name,
          'aria-pressed': on ? 'true' : 'false'
        });
        var url = c.swatchUrl || '';
        if (url && /^(https?:)?\/\//i.test(url)) {
          var img = h('span', {
            class: 'ck-cfg__swatch-img',
            role: 'img',
            'aria-label': c.name
          });
          img.style.backgroundImage = 'url("' + url.replace(/"/g, '%22') + '")';
          b.appendChild(img);
        } else {
          b.appendChild(h('span', { class: 'ck-cfg__swatch-name' }, esc(c.name)));
        }
        // CK COLOR GALLERY (lever): announce the picked color to the PDP gallery.
        // ORDER IS LOAD-BEARING — this bind must stay ABOVE the onPick bind below.
        // Same-target listeners fire in registration order, so this dispatch (and the
        // gallery repaint, which runs synchronously during dispatch) completes while
        // the swatch button is still in the DOM. onPick -> render() -> innerHTML=''
        // detaches the button, and a detached node cannot bubble events.
        // The onPick line below is intentionally untouched: cart/price flow unchanged.
        b.addEventListener('click', function () { b.dispatchEvent(new CustomEvent('ck:color', { bubbles: true, detail: c })); });
        b.addEventListener('click', function () { onPick(c.name); });
        box.appendChild(b);
      });
      if (!(colors && colors.length)) {
        box.appendChild(h('span', { class: 'ck-cfg__swatch-none' }, 'No colors available'));
      }
      return box;
    }
  });
  } 

  

  
  function normKey(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function blurbForVariant(full, v) {
    if (!full || !v) return '';
    var parts = String(full).split(/\bBUY\s+NOW\b/i);
    if (parts.length < 2) return '';
    var keys = (v.opts || []).concat([v.title]).map(normKey).filter(Boolean);
    var best = '', bestScore = 0;
    parts.forEach(function (p) {
      p = p.trim(); if (!p) return;
      var head = normKey(p.slice(0, 80));
      keys.forEach(function (k) {
        if (!k) return;
        var score = 0;
        if (head.indexOf(k) >= 0) score = k.length * 2;
        k.split(' ').forEach(function (t) { if (t.length > 3 && head.indexOf(t) >= 0) score += t.length; });
        if (score > bestScore) { bestScore = score; best = p; }
      });
    });
    return best;
  }
  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function bootPdp(root) {
    if (!root || root.hasAttribute('data-ck-init')) return;
    root.setAttribute('data-ck-init', '');
    var main = document.getElementById('pdp-main-image');
    var meta = window.__ckPdp || {};
    var variantImages = meta.variantImages || {};
    var variants = readJson('ck-pdp-variants') || meta.variants || null;
    var descFull = readJson('ck-pdp-desc');
    if (descFull == null) descFull = meta.descFull || '';
    if (variants) {
      meta.variants = variants;
      meta.descFull = descFull;
      window.__ckPdp = meta;
    }

    root.querySelectorAll('.pdp-thumb-grid__item[data-thumb-src]').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-thumb-src');
        if (main && src) {
          main.src = src;
          root.querySelectorAll('.pdp-thumb-grid__item').forEach(function (x) {
            x.classList.toggle('active', x === b);
          });
        }
      });
    });

    // ===========================================================================
    // CK COLOR GALLERY (lever install, 2026-07-24). Council-approved, 30 lines.
    // Data flow: swatch click -> ck:color event -> look up this color's image
    // URLs in the #ck-pdp-color-images island -> repaint the EXISTING thumb
    // slots in place + swap the hero. No nodes are created, moved, or removed;
    // videos and the View-all tile are never touched by JS.
    // Axis contract (do not merge these two meanings onto one flag):
    //   - hidden attribute on a thumb  = "this color has no URL for this slot"
    //     (per-slot, owned by JS below)
    //   - data-ck-clip on the grid + data-thumb-extra on slots = "behind View
    //     all" (grid-level, owned by the CSS rule in pdp-main.liquid)
    // Thumb CLICKS stay with the theme's existing per-thumb binds (verified:
    // they read data-thumb-src at click time and sweep .active) — that is why
    // there is no thumb-click handler here.
    // ===========================================================================
    var thumbGrid = root.querySelector('[data-thumb-grid]');                        // the thumb strip container
    var thumbBtns = thumbGrid ? [].slice.call(thumbGrid.querySelectorAll('[data-thumb-src]')) : []; // image slots only (never video tiles)
    var thumbImgs = thumbBtns.map(function (b) { return b.querySelector('img'); }); // cached child <img>s; guarded per-slot at paint time
    var moreBtn = thumbGrid && thumbGrid.querySelector('[data-thumb-more]');        // View-all tile (null when default gallery fits)
    var moreLab = moreBtn && moreBtn.querySelector('[data-thumb-more-label]');      // the "+N" text inside the tile
    var thumbLimit = parseInt(thumbGrid && thumbGrid.getAttribute('data-thumb-limit'), 10) || 18; // wall size from section setting
    var colorMap = readJson('ck-pdp-color-images') || {};                           // island: materialId -> URL array (|| {} => island null = safe no-op)

    root.addEventListener('ck:color', function (e) {
      var mid = e.detail ? e.detail.materialId : '';
      var u = colorMap['material-' + mid] || colorMap[mid] || [];                   // keys exist both prefixed and bare across the catalog
      if (typeof u === 'string') { try { u = JSON.parse(u); } catch (err) { u = []; } } // some metafield values are JSON *strings* (type varies per product)
      var urls = (Array.isArray(u) ? u : []).map(safeImgUrl).filter(Boolean);       // sanitize every URL; drop anything unsafe
      if (!thumbGrid || !urls.length) return;                                       // FAIL CLOSED: unknown/empty color never blanks the gallery
      var n = Math.min(urls.length, thumbBtns.length);                              // slot cap: surplus URLs dropped silently, never throw
      thumbBtns.forEach(function (b, i) {
        b.hidden = i >= n;                                                          // axis 1: slots beyond this color's URL count vanish
        b.classList.toggle('active', i === 0);                                      // first thumb becomes the active one
        if (i < n) b.setAttribute('data-thumb-src', urls[i]);                       // existing click binds read this attr at click time
        if (i < n && thumbImgs[i]) thumbImgs[i].src = urls[i];                      // guarded: a slot missing its <img> is skipped, not fatal
      });
      thumbGrid.toggleAttribute('data-ck-clip', n > thumbLimit);                    // axis 2: (re)arm the window every paint => also collapses an expanded grid
      if (moreBtn) moreBtn.hidden = n <= thumbLimit;                                // tile only shows when this color actually overflows
      if (moreLab && n > thumbLimit) moreLab.textContent = '+' + (n - thumbLimit + 1); // same formula Liquid uses: hidden = n - (limit - 1)
      if (main) main.src = urls[0];                                                 // hero = this color's primary photo
    });

    if (moreBtn) moreBtn.addEventListener('click', function () {
      thumbGrid.toggleAttribute('data-ck-clip');                                    // View all / collapse = one attribute flip; CSS does the rest
    });

    // Boot normalize: Liquid hides overflow extras with the hidden attribute; move
    // that window onto data-ck-clip so the View-all tile is LIVE before the first
    // color pick. At boot, hidden === overflow (Liquid hides nothing else), so the
    // blanket strip below is unambiguous. Both lines run in the same task — no
    // repaint between them — so the pre-JS render stays pixel-identical.
    if (moreBtn) thumbGrid.setAttribute('data-ck-clip', '');
    thumbBtns.forEach(function (b) { b.removeAttribute('hidden'); });

    var form = root.querySelector('#pdp-product-form') ||
      root.querySelector('form[action*="/cart/add"]') ||
      document.getElementById('pdp-product-form');
    var idSel = form && (form.querySelector('[data-variant-select]') || form.querySelector('select[name="id"]'));
    var optSels = form
      ? Array.prototype.slice.call(form.querySelectorAll('select.pdp-select, select[data-option-index]'))
      : [];

    // No variant has the chosen options: the form carries no id and the button says so, so a
    // combination that does not exist can never submit the one chosen before it.
    var NONE = { id: '', opts: [], title: '', price: '', compare: null, avail: false, label: 'Unavailable' };
    function applyVariant(v) {
      v = v || NONE;
      if (idSel) {
        idSel.disabled = !v.id; // a disabled select posts nothing, so no earlier id can reach the cart
        idSel.value = String(v.id);
        var opt = idSel.querySelector('option[value="' + String(v.id) + '"]');
        if (opt) opt.selected = true;
      }
      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = v.price || ''; });
      root.querySelectorAll('[data-compare-price]').forEach(function (el) {
        if (v.compare) { el.hidden = false; el.textContent = v.compare; }
        else { el.hidden = true; el.textContent = ''; }
      });
      root.querySelectorAll('[data-atc-price]').forEach(function (el) {
        el.textContent = v.price || '';
      });
      if (form) {
        var btn = form.querySelector('[data-atc-button]');
        if (btn) {
          btn.disabled = v.avail === false;
          var lab = btn.querySelector('[data-atc-label]');
          if (lab) {
            while (lab.firstChild) lab.removeChild(lab.firstChild);
            if (v.avail === false) {
              lab.appendChild(document.createTextNode(v.label || 'Sold out'));
            } else {
              lab.appendChild(document.createTextNode('Add to cart · '));
              var ps = document.createElement('span');
              ps.setAttribute('data-atc-price', '');
              ps.textContent = v.price || '';
              lab.appendChild(ps);
            }
          }
        }
      }
      var img = v.img || variantImages[String(v.id)];
      if (main && img) main.src = img;
      var intro = root.querySelector('[data-pdp-intro]');
      if (intro) {
        var blurb = blurbForVariant(descFull, v);
        if (blurb) intro.textContent = blurb;
      }
    }
    function matchVariant() {
      if (!variants || !variants.length || !optSels.length) return null;
      var chosen = optSels.map(function (s) { return s.value; });
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].opts || [];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (String(o[j]) !== String(chosen[j])) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }
    if (variants && optSels.length) {
      var onOpt = function () { applyVariant(matchVariant()); };
      optSels.forEach(function (s) { s.addEventListener('change', onOpt); });
      onOpt();
    }
  }

  function bootAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ck-vbar]').forEach(bootVbar);
    bootHeaderFit();
    scope.querySelectorAll('.pdp[data-section-id], .pdp-v8').forEach(bootPdp);
  }
  function start() {
    bootAll(document);
    document.addEventListener('shopify:section:load', function (e) {
      bootAll(e.target);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
